import { render, staticRenderFns } from "./IncidentTabs.vue?vue&type=template&id=4c0eb3de"
import script from "./IncidentTabs.vue?vue&type=script&lang=js"
export * from "./IncidentTabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports